import { render, staticRenderFns } from "./ProceedPaymentsLoader.vue?vue&type=template&id=7b17afa2&scoped=true&"
import script from "./ProceedPaymentsLoader.vue?vue&type=script&lang=js&"
export * from "./ProceedPaymentsLoader.vue?vue&type=script&lang=js&"
import style0 from "./ProceedPaymentsLoader.vue?vue&type=style&index=0&id=7b17afa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b17afa2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/vsts/work/1/s/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VContainer,VLayout,VProgressCircular})
